function handleGridCards() {
    const gridContainers = document.querySelectorAll('.grid-cards');
    if (!gridContainers.length) return;

    gridContainers.forEach(el => {
        const cards = el.querySelectorAll('.grid-card');

        cards.forEach(card => {
            const content = card.querySelector('.grid-card-content');
            const heading = card.querySelector('.heading');
            const description = card.querySelector('.description');
            const mq = window.matchMedia("(max-width: 991px)");

            if (!content || !heading || !description) return;

            function handleResize() {
                if (!mq.matches) {
                    const height = description.offsetHeight;
                    heading.style.transform = `translateY(${height}px)`;
                } else {
                    heading.style.transform = 'translateY(0px)';
                }
            }

            function handleHover() {
                if (!mq.matches) {
                    content.classList.add('active');
                    description.classList.add('show');
                    heading.style.transform = 'translateY(0)';
                }
            }

            function handleStatic() {
                if (!mq.matches) {
                    content.classList.remove('active');
                    description.classList.remove('show');
                }
                handleResize();
            }

            card.addEventListener('mouseenter', handleHover);
            card.addEventListener('mouseleave', handleStatic);

            // Initial height calculation
            handleResize();

            const resizeObserver = new ResizeObserver(handleResize);
            resizeObserver.observe(card);
        });
    });

    // Calculate heights on page load so that headings are positioned correctly at bottom of container
    window.addEventListener('load', () => {
        gridContainers.forEach(el => {
            const cards = el.querySelectorAll('.grid-card');
            cards.forEach(card => {
                const heading = card.querySelector('.heading');
                const description = card.querySelector('.description');
                if (!heading || !description) return;

                const transformHeight = description.offsetHeight;
                heading.style.transform = 'translateY(' + transformHeight + 'px)';
                const mq = window.matchMedia("(max-width: 991px)");
                if (mq.matches) {
                    heading.style.transform = 'translateY(0px)';
                }
            });
        });
    });
}

handleGridCards();
